import api from '../token';

export const ListServico = async () => {
  try {
    const response = await api.post('/getServico');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

